import * as libVotingPolicy from './votingPolicy';
const prefix = `votingRecommendations/`;
export const IDToName = ({ votingPolicyID, recommendationID }) => {
    return libVotingPolicy.IDToName({ votingPolicyID }) + '/' + prefix + recommendationID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4) {
        throw new Error(`bad voting recommendation name: ${name}`);
    }
    return {
        votingPolicyID: parts[1],
        recommendationID: parts[3],
    };
};
